export const tr = {
    'adjustments-rate': 'Teklifler, bunlara uygulanan düzenlemeler dikkate alınmadan gösterilir',
    audience_coverage: 'Hedef kitle kapsamı',
    'context-click-price': 'Ağlarda tıklama fiyatı',
    'context-price': 'Teklif (ağlarda)',
    coverage: 'Kapsam',
    'cpm-banner-set-context-price': 'Bin gösterim başına teklif belirt',
    'cpm-banner-title': 'Teklif düzenleme',
    'no-display-info':
        'Sistemin ağlarda (YRA ve harici ağlar) bu sözcük grubunun gösterimleri hakkında verisi yok. Bu nedenle, kapsam ve tıklama fiyatı tahmin edilemiyor. '
};
